import { render, staticRenderFns } from "./MaterialTable.vue?vue&type=template&id=0bc3b154&scoped=true"
import script from "./MaterialTable.vue?vue&type=script&lang=js"
export * from "./MaterialTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc3b154",
  null
  
)

export default component.exports